import { Children } from "react";

import Box from "ds/components/Box";

type TileCheckboxGridProps = {
  children: React.ReactNode;
  // Overrides the auto-computed column count below (e.g. when 2 columns would otherwise
  // be picked for exactly 4 children, but the layout calls for a single row of 4).
  columns?: number;
};

const TileCheckboxGrid = ({ children, columns }: TileCheckboxGridProps) => {
  const childrenCount = Children.count(children);
  const isSingle = childrenCount === 1;
  const twoColumn = childrenCount === 2 || childrenCount === 4;
  let gridTemplate = "repeat(3, 1fr)";

  if (isSingle) {
    gridTemplate = "1fr";
  }

  if (twoColumn) {
    gridTemplate = "repeat(2, 1fr)";
  }

  if (columns) {
    gridTemplate = `repeat(${columns}, 1fr)`;
  }

  return (
    <Box grid gridTemplate={gridTemplate} gap="large">
      {children}
    </Box>
  );
};

export default TileCheckboxGrid;
